<!-- <a matTooltip="{{this.translate.data['TOOLTIPVIEWUSERINFO'] | translate}}" [routerLink]="routerLinkViewUser">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_view}}</mat-icon>
</a> -->
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPVIEWUSERINFO'] | translate}}" [routerLink]="routerLinkViewUser">Benutzerinformation</button>
</a>

<!-- <a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPUSERPROFILE'] | translate}}" [routerLink]="routerLinkEditUser">Benutzerprofil</button>
</a> -->

<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPREMOVEUSER'] | translate}}" (click)="deleteUser()">Entfernen</button>
</a>


<!-- <a matTooltip="{{this.translate.data['TOOLTIPUSERPROFILE'] | translate}}" [routerLink]="routerLinkEditUser">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_edit}}</mat-icon>
</a>

<a matTooltip="{{this.translate.data['TOOLTIPREMOVEUSER'] | translate}}" (click)="deleteUser()"
    [hidden]="!(icon_delete)">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_delete}}</mat-icon>
</a> -->
